const exercises = [
  {
    title: "Agents of the Cold War",
    video: "../data/exercise-videos/history-cold-war/history-cold-war.mp4"
  },
  {
    title: "Applause Please",
    video: "../data/exercise-videos/entertain-applause/entertain-applause.mp4"
  },
  {
    title: "Ascend Mount Everest",
    video: "../data/exercise-videos/world-everest/world-everest.mp4"
  },
  {
    title: "Athletic Weightlifter",
    video: "../data/exercise-videos/sport-weightlifter/sport-weightlifter.mp4"
  },
  {
    title: "Barn Dance USA",
    video: "../data/exercise-videos/world-barn-dance/world-barn-dance.mp4"
  },
  {
    title: "Boxing Champ",
    video: "../data/exercise-videos/sport-boxing/sport-boxing.mp4"
  },
  {
    title: "Bruce Lee",
    video: "../data/exercise-videos/entertain-kung-fu/entertain-kung-fu.mp4"
  },
  {
    title: "Buddha Under the Tree",
    video: "../data/exercise-videos/history-buddha/history-buddha.mp4"
  },
  {
    title: "Chariot Racerunner",
    video: "../data/exercise-videos/sport-chariots/sport-chariots.mp4"
  },
  {
    title: "Chinese Thai Chi Master",
    video: "../data/exercise-videos/world-thai-chi/world-thai-chi.mp4"
  },
  {
    title: "Clansmen Marching",
    video: "../data/exercise-videos/history-bagpipe/history-bagpipe.mp4"
  },
  {
    title: "Combs and Brylcreem",
    video: "../data/exercise-videos/entertain-brylcreem/entertain-brylcreem.mp4"
  },
  {
    title: "Dennis Hopper Easy Rider",
    video: "../data/exercise-videos/entertain-easy-rider/entertain-easy-rider.mp4"
  },
  {
    title: "Do the Can Can",
    video: "../data/exercise-videos/world-can-can/world-can-can.mp4"
  },
  {
    title: "Downhill Skier",
    video: "../data/exercise-videos/sport-ski/sport-ski.mp4"
  },
  {
    title: "Drake Goes Bowling",
    video: "../data/exercise-videos/history-drake/history-drake.mp4"
  }
];

export default exercises;
